import UsersTabItem from './UsersTabItem'

export default UsersTabItem
